export default "__VITE_ASSET__DPUfjrz5__"